import { FirebaseField } from '@ypp-portal/models/course/firebaseCourseData';
import React from 'react';
import { useParams } from 'react-router-dom';
import firebase from 'firebase/app';
import LoadingPage from '@components/common/Loading';
import ErrorPage from '@components/common/Error';
import PageHeader from '@components/common/PageHeader';
import Paginator from '@components/common/pagination/Paginator';
import { usePaginatedQuery } from '@components/common/pagination/usePaginatedQuery';
import CourseReviewBox from '@components/admin/course/review/CourseReviewBox';
import { CourseDataConverter } from '@data/course/CourseDataConverter';

enum RouteField {
  CompSciEng = 'computer-science-and-engineering',
  Humanities = 'humanities-and-social-sciences',
  SciMath = 'science-and-math',
  Lifestyle = 'special-skills-and-lifestyle',
  Arts = 'arts',
  WorldLang = 'world-languages',
}

const mapRouteFieldToFirebaseField = (route: RouteField) => {
  switch (route) {
    case RouteField.CompSciEng:
      return FirebaseField.CompSciEng;
    case RouteField.Humanities:
      return FirebaseField.Humanities;
    case RouteField.SciMath:
      return FirebaseField.SciMath;
    case RouteField.Lifestyle:
      return FirebaseField.Lifestyle;
    case RouteField.Arts:
      return FirebaseField.Arts;
    case RouteField.WorldLang:
      return FirebaseField.WorldLang;
  }
};

const converter = new CourseDataConverter();

const CourseReviewPage: React.FC = () => {
  const { field } = useParams<{ field: RouteField }>();

  const queryField = mapRouteFieldToFirebaseField(field);

  const baseQuery = firebase
    .firestore()
    .collection('classes')
    .orderBy('name')
    .where('archived', '==', false)
    .where('frozen', '==', true)
    .where('field', '==', queryField)
    .withConverter(converter);

  const { result, next, previous, hasNext, hasPrevious, loading, error } = usePaginatedQuery(
    baseQuery,
    5
  );

  if (loading) {
    return <LoadingPage></LoadingPage>;
  }

  if (error || !result) {
    return <ErrorPage></ErrorPage>;
  }

  return (
    <div className='w-full h-full overflow-auto'>
      <PageHeader text='COURSE REVIEW'></PageHeader>
      <div className='w-full flex flex-col'>
        <div className='w-full mt-12 flex-grow'>
          {result.docs.map((doc) => (
            <CourseReviewBox key={doc.id} doc={doc} />
          ))}
        </div>
        <Paginator
          onNext={next}
          onPrevious={previous}
          hasNext={hasNext}
          hasPrevious={hasPrevious}
        ></Paginator>
      </div>
    </div>
  );
};

export default CourseReviewPage;
